import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { RecurringPushNotificationGetByIdUseCaseInterface } from 'domain/usecases';

export class RemoteRecurringPushNotificationGetById
  implements RecurringPushNotificationGetByIdUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: RecurringPushNotificationGetByIdUseCaseInterface.Params,
  ): Promise<RecurringPushNotificationGetByIdUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${params.id}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
